import React, { useState } from "react";
import axios from "axios";
import Style from "../Style/FeaturedAdmin.module.scss";
const baseURL = process.env.REACT_APP_BASE_URL;

const FeaturedAdmin = () => {
  const [formData, setFormData] = useState({
    title: "",
    short_description: "",
    image: null,
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("title", formData.title);
    data.append("short_description", formData.short_description);
    data.append("image", formData.image);

    try {
      await axios.post(`${baseURL}/api/skills`, data);
      setMessage("Skill added successfully!");
      setFormData({ title: "", short_description: "", image: null });
    } catch (error) {
      setMessage("Failed to add skill.");
      console.error(error);
    }
  };

  return (
    <div className={Style.FeaturedAdmin}>
      <h2>Add Featured Skill</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="short_description"
          placeholder="Short Description"
          value={formData.short_description}
          onChange={handleChange}
          required
        />
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={handleChange}
          required
        />
        <button type="submit">Add Skill</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default FeaturedAdmin;
